import { StatusIndicator } from "@nulogy/components";
import WorkOrder from "domain/WorkOrder";
import React from "react";
import styled, { useTheme } from "styled-components";

const WORK_ORDER_CARD_STATUSES = {
  [WorkOrder.SCHEDULED_STATUS_TYPES.UNDERSCHEDULED]: {
    backgroundColor: "lightBlue",
    color: "darkGrey",
  },
  [WorkOrder.SCHEDULED_STATUS_TYPES.OVERSCHEDULED]: {
    backgroundColor: "yellow",
    color: "darkGrey",
  },
  [WorkOrder.SCHEDULED_STATUS_TYPES.FULLY_SCHEDULED]: { backgroundColor: "darkBlue", color: "white" },
  [WorkOrder.STATUS_TYPES.CANCELLED]: { backgroundColor: "darkGrey", color: "white" },
  [WorkOrder.COMPLETED_LABEL]: { backgroundColor: "green", color: "white" },
};

export const InlineStatus = styled(StatusIndicator)`
  background-color: ${(props) => props.backgroundColor};
  margin-left: 4px;
  color: ${(props) => props.color};
`;

export const SidebarStatus = styled(InlineStatus)`
  position: absolute;
  top: -9px;
  right: 20px;
  cursor: default;
  z-index: 1;
`;

export default function WorkOrderCardStatus({ workOrder, inline }) {
  const theme = useTheme();
  const cardStatus = getCardStatus({ inline, workOrder });
  if (!cardStatus) return null;

  const { color, backgroundColor } = WORK_ORDER_CARD_STATUSES[cardStatus];
  const Status = inline ? InlineStatus : SidebarStatus;

  return (
    <Status
      backgroundColor={theme.colors[backgroundColor]}
      className="spec-work-order-card-status"
      color={theme.colors[color]}
      data-testid="work-order-card-status"
    >
      {formatCardStatus(cardStatus)}
    </Status>
  );
}

function formatCardStatus(cardStatus) {
  return cardStatus.replace(/_/g, " ");
}

function getCardStatus({ workOrder, inline }) {
  if (!workOrder) return null;
  const cardStatus = WorkOrder.cardStatus(workOrder);
  if (!cardStatus) return null;
  if (!inline && cardStatus === WorkOrder.SCHEDULED_STATUS_TYPES.UNDERSCHEDULED) return null;

  return cardStatus;
}
